var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 40,
    viewBox: "0 0 216 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.8689C0.643396 37.3574 3.70072 40 7.37525 40H15.1507L9.31757 31.56C9.15932 31.562 9.00017 31.5631 8.84012 31.5631H0V33.8689Z",
    fill: "url(#paint0_linear_8248_62562)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.5004H8.27586C11.4107 23.5004 13.7513 22.8337 15.2978 21.5004C16.8443 20.1254 17.6175 18.2503 17.6175 15.8753C17.6175 13.4586 16.8443 11.5835 15.2978 10.2502C13.7513 8.91683 11.4107 8.25015 8.27586 8.25015H0V23.5004Z",
    fill: "url(#paint1_linear_8248_62562)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84012 0C12.7691 0 16.1546 0.645845 18.9969 1.93754C21.8391 3.18756 24.0334 5.00009 25.5799 7.37513C27.1264 9.75018 27.8997 12.5836 27.8997 15.8753C27.8997 19.1253 27.1264 21.9379 25.5799 24.3129C24.0334 26.6463 21.8391 28.438 18.9969 29.688C18.9682 29.7006 18.9396 29.7132 18.9108 29.7256L26.0928 40H32.5001C36.6422 40 40 36.6421 40 32.4999V7.50006C40 3.35789 36.6422 0 32.5001 0H8.84012Z",
    fill: "url(#paint2_linear_8248_62562)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7998 32.3529V7.14282H64.313C66.6156 7.14282 68.5944 7.51497 70.2494 8.25927C71.9284 9.00357 73.2237 10.084 74.1351 11.5006C75.0466 12.8931 75.5023 14.5498 75.5023 16.4706C75.5023 18.3673 75.0466 20.012 74.1351 21.4045C73.2237 22.7731 71.9284 23.8295 70.2494 24.5738C68.5944 25.2941 66.6156 25.6542 64.313 25.6542H56.7575L59.9236 22.665V32.3529H52.7998ZM68.3785 32.3529L62.1183 23.1692H69.7098L76.006 32.3529H68.3785ZM59.9236 23.4213L56.7575 20.144H63.8812C65.3683 20.144 66.4717 19.8199 67.1912 19.1716C67.9348 18.5234 68.3066 17.623 68.3066 16.4706C68.3066 15.2941 67.9348 14.3817 67.1912 13.7335C66.4717 13.0852 65.3683 12.7611 63.8812 12.7611H56.7575L59.9236 9.48376V23.4213Z",
    fill: "#37BD6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8588 16.9027H100.552V22.2329H88.8588V16.9027ZM89.3625 26.8427H102.531V32.3529H82.3107V7.14282H102.063V12.653H89.3625V26.8427Z",
    fill: "#37BD6B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.867 32.8571C113.02 32.8571 111.341 32.545 109.83 31.9207C108.343 31.2725 107.107 30.3481 106.124 29.1476L110.01 24.5378C110.681 25.4021 111.377 26.0624 112.096 26.5186C112.816 26.9507 113.572 27.1668 114.363 27.1668C116.474 27.1668 117.529 25.9423 117.529 23.4934V12.653H108.822V7.14282H124.581V23.0612C124.581 26.3505 123.754 28.8115 122.099 30.4441C120.444 32.0528 118.033 32.8571 114.867 32.8571Z",
    fill: "#37BD6B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.816 16.9027H150.509V22.2329H138.816V16.9027ZM139.319 26.8427H152.488V32.3529H132.268V7.14282H152.02V12.653H139.319V26.8427Z",
    fill: "#37BD6B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.867 16.9027H177.56V22.2329H165.867V16.9027ZM166.371 26.8427H179.539V32.3529H159.319V7.14282H179.071V12.653H166.371V26.8427Z",
    fill: "#37BD6B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.37 32.3529V7.14282H192.235L202.669 24.2857H199.575L209.721 7.14282H215.585L215.657 32.3529H209.109L209.037 17.1188H210.152L202.561 29.8679H199.395L191.587 17.1188H192.954V32.3529H186.37Z",
    fill: "#37BD6B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8248_62562",
    x1: -28.9664,
    y1: -30,
    x2: 39.7794,
    y2: 40.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8248_62562",
    x1: -28.9664,
    y1: -30,
    x2: 39.7794,
    y2: 40.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8248_62562",
    x1: -28.9664,
    y1: -30,
    x2: 39.7794,
    y2: 40.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#37BD6B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.37adb55b2bb6683f34b0c3cf025ea313.svg";
export { ForwardRef as ReactComponent };